module.exports = __webpack_public_path__ + "static/media/br.78de6acf.svg";